/**
 * @author Coffee
 * @date 2019-08-21
 */
import request from 'crm/utils/request'
import api from 'crm/common/api/wechat-setting'

export async function info() {
    return request(api.info.url)
}

export async function update(payload) {
    return request(api.update.url, {
        method: api.update.type,
        body: payload.body,
    })
}
